import React from "react";
import "./index.scss";
import logo from "./../../images/logo.svg";
import logoText from "./../../images/logo_text.svg";

const Home = function() {
  return (
    <div className="home">
      <div className="home__logo">
        <img src={logo} alt="logo_me" />
        <img src={logoText} alt="logo_last" />
      </div>
      <div className="home__content">
        <div className="home__content-title">
          <span>Hola,</span>
          <span>Soy Jose Veliz,</span>
          <span>Desarrollador Web.</span>
        </div>
        <div className="home__content-subtitle">
          <div>
            <span>Fullstack Javascript developer / Freelancer</span>
          </div>
          <div>
            <span>
              Correo:{" "}
              <a href="mailto:jose.veliz.francia@gmail.com">
                jose.veliz.francia@gmail.com
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className="home__image">
        <h1 className="zetagh">ZetaGH</h1>
      </div>
    </div>
  );
};

export default Home;
